import 'slick-carousel';
import { findFlagUrlByIso2Code } from 'country-flags-svg';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    function docReady(fn) {
      // see if DOM is already available
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
          // call on next available tick
          setTimeout(fn, 1);
      } else {
          document.addEventListener('DOMContentLoaded', fn);
      }
    }
  
  

    // COUNTRY FLAGS //
    const countries_list=document.getElementById('countries_list');

    if(countries_list){
      const flag_active=document.getElementById('flag_active');
      var flag_current=document.getElementById('flag_current');
      var allCountriesItems=countries_list.querySelectorAll('li');

      var rtl=false;
      if(document.body.classList.contains('rtl')==true){
        rtl=true;
      }

      

      allCountriesItems.forEach(function(item){
        let flagCode=item.dataset.flag;
        let flagSVG='';

        if(flagCode=='GLOB'){
          flagSVG=item.querySelector('img').src;
        }else{
          flagSVG=findFlagUrlByIso2Code(flagCode);
        }

        if(item.querySelector('img')){
          item.querySelector('img').src=flagSVG;
        }


        if(flag_current){
          flag_active.innerHTML=flag_current.innerHTML; 
        }
      });
    }
    // END COUNTRY FLAGS //


    // HEADER NAV //
    var nav_parent=document.querySelectorAll('[data-action="dropdown"] > a');

    const handleClickNav = (e) => {
      e.preventDefault();
      let parent=e.currentTarget.parentNode;
      let allParents=document.querySelectorAll('.submenu--active');

      allParents.forEach(function(e){
        e.classList.remove('submenu--active');
      });
      
      if(parent.classList.contains('submenu--active')){
        parent.classList.remove('submenu--active');
      }else{
        parent.classList.add('submenu--active');
      }
      
    }

    nav_parent.forEach(node => {
      node.addEventListener('click', handleClickNav);
    });

    document.getElementById('nav__close').addEventListener('click', function(){
      document.getElementById('burger').checked = false;
      document.body.classList.remove('fixed','w-full');
    });



    document.getElementById('burger').addEventListener('click', function(){
      if(this.checked){
        document.body.classList.add('fixed','w-full');
      }else{
        document.body.classList.remove('fixed','w-full');
      }
    })



    /* SLIDER */
    $('.dph-slider-block').each(function(){
      var sliderList=$(this).find('.slider__list').first();
      var sliderPagin=$(this).find('.slider__pagination');
      var slideNumber=$(this).data('number');

       

      sliderList.on('init reInit afterChange', function(event, slick, currentSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        var slidesToShow = slick.slickGetOption('slidesToShow');
        var curPage = parseInt((i-1)/slidesToShow) + 1;
        var lastPage =  parseInt((slick.slideCount-1)/slidesToShow) + 1;
        sliderPagin.find('.curr').text(curPage);
        sliderPagin.find('.count').text(lastPage);
      });

      sliderList.slick({
        arrows: true,
        rtl: rtl,
        speed: 300,
        slidesToShow:slideNumber,
        centerMode: false,
        swipeToSlide:true,
        slidesToScroll: slideNumber, 
        nextArrow: $(this).find('.slider__next'),
        prevArrow: $(this).find('.slider__prev'),
        dots: true,
        appendDots: $('.slider__bullets'),
        adaptiveHeight: true,

        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1, 
              centerMode: false,
              adaptiveHeight: true,
            },
          },
        ],
      });
    }); 


    // POPUP VIDEO //
    var popup_video=document.getElementById('popup__video');
    var video_button=document.querySelectorAll('[data-type=video]');

    function handleClickVideo(e) {
      e.preventDefault();
      
      let video_url=this.href;
      
      popup_video.querySelector('iframe').src=video_url
      popup_video.classList.remove('hidden');    
      
    }

    video_button.forEach(function(node){
      node.addEventListener('click', handleClickVideo);
    });

    
    var popup_close=document.querySelector('.popup__close');

    popup_close.addEventListener('click', function(){
      this.parentNode.parentNode.classList.add('hidden');
    });




    /* NAV TABS PANEL */
    if ( window.location.hash ) scroll(0,0);
    if(document.getElementById('ajaxUrl')!=null){
      var ajaxUrl=document.getElementById('ajaxUrl').dataset.ajaxurl;
    }
    var wrapper=document.getElementById('tab-panel');
    var navtabs__list=document.querySelectorAll('.navtabs');
    
    
    
    function loadPostAjax(childId){
        $.ajax({
            url : ajaxUrl,
            method : 'POST',
            data : {
                action:'show_child_page',
                childId: childId,
            },
            success : function(data) {
              wrapper.innerHTML=data; 
              // *only* if we have anchor on the url
                if(window.location.hash) {

                  // smooth scroll to the anchor id
                  $('html, body').animate({
                      scrollTop: ($(window.location.hash).offset().top-200) + 'px',
                  }, 1000, 'swing');
              }
            },
            error : function() {
                console.log( 'Erreur…' );
            },
        });
    }

    function loadPostShow(childId){
      var panelSelect=document.getElementById(childId);
      wrapper.innerHTML=panelSelect.innerHTML; 
    }

    /* first detect if the nav type is redirection or ajax behaviour */
    if(navtabs__list) {
      navtabs__list.forEach(function(e){
        var navType=e.dataset.navtype;
        var navtabs__items=e.querySelectorAll('.navtabs__item');
        

        docReady(function() {
          
          if(navType=='ajax' || navType=='anchor'){
            let hash=location.hash.split('#')[1];
            
            
            const navtabs__item_first=e.querySelector('.navtabs__item');

            let childId=navtabs__item_first.dataset.id;
            navtabs__item_first.classList.add('active');
            

            navtabs__items.forEach(function(item){
              if(hash!==undefined && hash==item.dataset.slug){
                item.classList.add('active');
                navtabs__item_first.classList.remove('active');
                childId=item.dataset.id; 
              }
            });

            if(navType=='ajax'){
              loadPostAjax(childId);
            }else{          
              loadPostShow(childId);
            }
          }else{
            var pageSlug=document.querySelector('[data-page]').dataset.slug;
            navtabs__items.forEach(function(f){
              if(f.dataset.slug==pageSlug){
                f.classList.add('active');
              }
            });
          }
        });

        if(navType=='ajax' || navType=='anchor'){
          navtabs__items.forEach(function(f){
            f.addEventListener('click',function(){
              navtabs__items.forEach((item) =>  {
                item.classList.remove('active'); 
              });
              
              let childId=this.dataset.id;           
              this.classList.add('active');


              if(navType=='ajax'){
                loadPostAjax(childId);
              }else{
                loadPostShow(childId);
              }
              
            },false);
          })
        }
      });
    }

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js